/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {ARMcontext} from '../../utils/context/context';
import {NavBar, NavLeft, NavRight, NavBarWrapper, MobileWrapper, MobileMenu, MenuIcon, MobileHide} from './styles';
import {TeamLogo, NavbarLink, /*NavbarButton,*/ NavbarSelector, FluidContainer} from '../';

export default () => {
  const {user} = React.useContext(ARMcontext);

  return (
    <>
      <NavBar data-cy="navbar">
        <FluidContainer>
          <NavBarWrapper>
            {(user.role === 'org-admin' || user.role === 'coach' || user.role === 'player') && (
              <>
                <NavLeft>
                  <TeamLogo mHeight="27px" mTop="18px" />
                  <NavbarLink title="PLAYERS / TEAMS" path={user.role === 'player' ? "/player-portal":"/teams"} recursivePath="/players/" />
                  {(user.role === 'org-admin' || user.data.isAdmin) && <NavbarLink title="ADMIN" path="/admin" />}
                  <NavbarLink title="HOW TO VIDEOS" path="/how-to-videos" />
                </NavLeft>
                <NavRight>
                  {/*<div>
                    <NavbarButton xmargin={'4px'} title="Team Arm Care" path="/armcare" />
                    <NavbarButton xmargin={'4px'} title="Velocity Test" path="/velocity" />
                    <NavbarButton xmargin={'4px'} title="Enter Workloads" path="/workloads" />
                  </div> */}
                  {user.data ? (
                    <>
                      {user.role === 'org-admin' ? (
                        <>
                          <NavbarSelector src={user.data?.organization?.picture || undefined} />
                        </>
                      ) : (
                        <>
                          <NavbarSelector src={user.data.picture || undefined} />
                        </>
                      )}
                    </>
                  ) : (
                    <NavbarSelector />
                  )}
                </NavRight>
              </>
            )}
          </NavBarWrapper>
          <MobileWrapper>
            <MobileMenu>
              <MenuIcon />
              <MobileHide>
                <NavbarLink title="PLAYERS / TEAMS" path="/teams" recursivePath="/players/" />
                {(user.role === 'org-admin' || user.data.isAdmin) && <NavbarLink title="ADMIN" path="/admin" />}
                <NavbarLink title="HOW TO VIDEOS" path="/how-to-videos" />
                {/* <NavbarLink title="TEAM ARM CARE" path="/armcare" />
                <NavbarLink title="VELOCITY TEST" path="/velocity" />
                <NavbarLink title="ENTER WORKLOADS" path="/workloads" /> */}
              </MobileHide>
            </MobileMenu>
            <TeamLogo mHeight="27px" mTop="18px" />
            <NavbarSelector src={user?.data?.organization?.picture || user?.data?.picture || undefined} />
          </MobileWrapper>
        </FluidContainer>
      </NavBar>
    </>
  );
};
